import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

//

export const PlanListApi = (data) => API.get(`${URL.PLAN_LIST_URL}/${data.clubId}`, data)
export const PlanCreateApi = (data) => API.post(`${URL.PLAN_CREATE_URL}`, data)
export const MembershipPlanList = (data) => API.get(`${URL.MEMBERSHIP_PLAN_LIST}`, data)
